import { inject, Injectable } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';

import { ReorderLocationsFacade } from '@recruitee/locations';

import { RequisitionFormManagerService } from '../../services/requisition-form-manager.service';

@Injectable()
export class ReorderLocationsRequisitionFacade extends ReorderLocationsFacade {
  private readonly requisitionFormManager = inject(RequisitionFormManagerService);

  public get locationsControl() {
    return <FormArray<FormControl>>this.requisitionFormManager.form.controls.locationIds!;
  }
}
